import React, { createContext, useContext, useState, useMemo } from "react";

const ProductionFilterContext = createContext();

export const useProductionFilter = () => useContext(ProductionFilterContext);

export const ProductionFilterProvider = ({ children }) => {
  const currentYear = new Date().getFullYear();
  // 'all' represents "All Time" for year
  const [selectedYear, setSelectedYear] = useState(currentYear);
  // Q1, Q2, Q3, Q4, or 'all' for All Quarters
  const [selectedQuarter, setSelectedQuarter] = useState("all");

  const { startDate, endDate } = useMemo(() => {
    if (selectedYear === "all") {
      return { startDate: null, endDate: null };
    }

    let startMonth = 0; // Jan
    let endMonth = 11; // Dec
    let endDay = 31;

    if (selectedQuarter !== "all") {
      switch (selectedQuarter) {
        case "Q1":
          startMonth = 0;
          endMonth = 2;
          endDay = 31; // Jan-Mar
          break;
        case "Q2":
          startMonth = 3;
          endMonth = 5;
          endDay = 30; // Apr-Jun
          break;
        case "Q3":
          startMonth = 6;
          endMonth = 8;
          endDay = 30; // Jul-Sep
          break;
        case "Q4":
          startMonth = 9;
          endMonth = 11;
          endDay = 31; // Oct-Dec
          break;
        default:
          break;
      }
    }

    const startDate = new Date(selectedYear, startMonth, 1);
    const endDate = new Date(selectedYear, endMonth, endDay, 23, 59, 59, 999);

    return { startDate, endDate };
  }, [selectedYear, selectedQuarter]);

  const value = {
    selectedYear,
    setSelectedYear,
    selectedQuarter,
    setSelectedQuarter,
    startDate,
    endDate,
  };

  return (
    <ProductionFilterContext.Provider value={value}>{children}</ProductionFilterContext.Provider>
  );
};
